export const vNoSave = {
  mounted(el: any) {
    // 1. CSS 层面禁止选中和系统默认菜单
    el.style.webkitUserSelect = 'none' // Chrome/Safari/Opera
    el.style.mozUserSelect = 'none' // Firefox
    el.style.msUserSelect = 'none' // IE/Edge
    el.style.userSelect = 'none' // Standard

    // iOS 关键：禁止触摸时的系统默认菜单（如长按放大镜、保存菜单）
    el.style.webkitTouchCallout = 'none'

    // 禁止图片拖拽
    el.setAttribute('draggable', 'false')

    // 2. JS 层面拦截事件（保存引用以便 unmounted 时移除）
    const onContextmenu = (e: any) => {
      e.preventDefault()
      return false
    }
    const onTouchstart = (e: any) => {}
    el.addEventListener('contextmenu', onContextmenu)
    el.addEventListener('touchstart', onTouchstart, { passive: false })

    // 额外的一层保护：覆盖一层透明遮罩 (这是最彻底的方法)
    const mask = document.createElement('div')
    mask.style.position = 'absolute'
    mask.style.top = '0'
    mask.style.left = '0'
    mask.style.width = '100%'
    mask.style.height = '100%'
    mask.style.opacity = '0'
    mask.style.zIndex = '10' // 确保在图片之上
    const onMaskContextmenu = (e: Event) => {
      e.preventDefault()
      e.stopPropagation()
    }
    mask.addEventListener('contextmenu', onMaskContextmenu)

    // 只有当父元素定位不是 static 时，绝对定位才有效
    let scrollContainer: HTMLElement | null = null
    let parent = el.parentElement
    while (parent) {
      if (typeof window !== 'undefined') {
        const parentStyle = window.getComputedStyle(parent)
        if (parentStyle.overflowY === 'auto' || parentStyle.overflowY === 'scroll') {
          scrollContainer = parent
          break
        }
      }
      parent = parent.parentElement
    }

    let parentPositionRestored = false
    if (el.parentElement && typeof window !== 'undefined') {
      const parentPosition = window.getComputedStyle(el.parentElement).position
      if (parentPosition === 'static') {
        el.parentElement.style.position = 'relative'
        parentPositionRestored = true
      }
    }

    el.parentElement?.appendChild(mask)

    // 供 unmounted 清理使用
    ;(el as any).__noSaveMeta = {
      mask,
      onContextmenu,
      onTouchstart,
      onMaskContextmenu,
      parentPositionRestored,
      parent: el.parentElement
    }
  },
  unmounted(el: any) {
    const meta = (el as any).__noSaveMeta as
      | {
          mask: HTMLDivElement
          onContextmenu: (e: any) => void
          onTouchstart: (e: any) => void
          onMaskContextmenu: (e: Event) => void
          parentPositionRestored: boolean
          parent: HTMLElement | null
        }
      | undefined
    if (!meta) return

    meta.mask.removeEventListener('contextmenu', meta.onMaskContextmenu)
    meta.mask.remove()
    el.removeEventListener('contextmenu', meta.onContextmenu)
    el.removeEventListener('touchstart', meta.onTouchstart, { passive: false } as any)

    if (meta.parentPositionRestored && meta.parent) {
      meta.parent.style.position = ''
    }

    el.style.webkitUserSelect = ''
    el.style.mozUserSelect = ''
    el.style.msUserSelect = ''
    el.style.userSelect = ''
    el.style.webkitTouchCallout = ''
    el.removeAttribute('draggable')

    delete (el as any).__noSaveMeta
  }
}
